import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";

var _hoisted_1 = /*#__PURE__*/_createTextVNode("返回");

export function render(_ctx, _cache) {
  var _this = this;

  var _component_el_button = _resolveComponent("el-button");

  var _component_el_empty = _resolveComponent("el-empty");

  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_empty, {
    "image-size": 700,
    image: require("../assets/404.gif"),
    description: "糟糕，您访问的页面跑到外太空啦!"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_button, {
        type: "primary",
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return _this.$router.go(-1);
        })
      }, {
        default: _withCtx(function () {
          return [_hoisted_1];
        }),
        _: 1
      })];
    }),
    _: 1
  }, 8, ["image"])]);
}